import { LitElement, html, css } from 'lit';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import { Liquid } from 'liquidjs';

class DplLiquidComponent extends LitElement {
    static properties = {
        data: { type: String },
        queries: { type: Object, converter: {
                fromAttribute: (value, type) => {
                    return JSON.parse(value.replaceAll("'", '"'));
                },
                toAttribute: (value, type) => {
                    console.log('toAttribute:', value, type)
                    return JSON.stringify(value);
                }
            } },
        templateContent: { state: true },
        isLoading: { state: true }
    };

    _data = {};
    set data(value) {
        console.log(`data[${typeof value}]:`, value);
        if (value === this._data)
            return;
        try {
            this._data = JSON.parse(value.replaceAll("'", '"'));
            console.log('data is json. value=', this._data)
        }catch (error) {
            this._data = value;
            console.log('data is not json. value=', this._data)
        }
        if(this._setupComplete)
            this.updateTemplate();
    }
    get data() {
        return this._data;
    }

    constructor() {
        super();
        this.queries = {};
        this.templateContent = '';
        this.isLoading = true;
    }

    async firstUpdated() {
        await this.updateTemplate();
        this._setupComplete = true;
    }

    async updateTemplate() {
        this.isLoading = true;

        const template = this.getSlotContent();
        if (template) {
            if (!this._engine)
                this._engine = new Liquid();
            try {
                this.templateContent = await this._engine.parseAndRender(template, {data: this._data, ...await this.queryResults()});
                console.log('templateContent:', this.templateContent)
            } catch (error) {
                console.error('Error rendering template:', error);
            }
        }
        this.isLoading = false;
    }

    getSlotContent() {
        const slot = this.shadowRoot.querySelector('slot');
        const nodes = slot.assignedNodes({flatten: true});
        let content = '';

        return nodes[0].outerHTML.toString();

        // todo - find out why outerHTML is not working
        nodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE) {
                content += node.textContent; // or `node.innerHTML` for HTML content
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                console.log('node.outerHTML:', node.outerHTML)
                content += node.outerHTML.toString();
            }
        });

        return content;
    }

    static styles = css`
                :host {
                    display: block;
                    transition: opacity 0.3s ease;
                    opacity: 1;
                }
                :host([isLoading]) {
                    opacity: 0.5;
                }
                slot {
                    display: none;
                }
            `;

    render() {
        return html`
                    <slot @slotchange="${this.updateTemplate}"></slot>
                    ${unsafeHTML(this.templateContent)}
                `;
    }

    async queryResults() {
        const promises = [];
        const results = {}
        for (const [key, value] of Object.entries(this.queries)) {
            if (value) {
                promises.push(new Promise(async (resolve, reject) => {
                    results[key] = await this.query(value);
                    resolve();
                }));
            }
        }
        await Promise.all(promises);
        return results;
    }
    async query(query) {
        const request = await fetch(query);
        if (!request.ok) {
            console.error('Error fetching query:', request);
            return 'Error fetching query';
        }
        try {
            return await request.json();
        } catch (error) {
            console.error('Error parsing query response:', error);
            return 'Error parsing query response';
        }
    }
}

customElements.define('dpl-liquid', DplLiquidComponent);